/** Width of the main app sidebar when docked (px). Must match AppLayout dock column. */
export const SIDEBAR_DOCK_WIDTH = 280;
